var e, a;
function i() {
  if (a) return e;
  a = 1;
  var t = function(u) {
    return u.reduce(function(n, r) {
      return Array.isArray(r) ? n.concat(t(r)) : n.concat(r);
    }, []);
  };
  return e = t, e;
}
export {
  i as __require
};
